import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["event", "children"];
import React from 'react';
import { Button } from 'semantic-ui-react';
import Event from '../../darkmatter/Event';
import { ChildrenPropType } from '../../services/proptypes';

var EventButton = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(EventButton, _React$PureComponent);

  function EventButton() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = EventButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        event = _this$props.event,
        children = _this$props.children,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return /*#__PURE__*/React.createElement(Event, {
      event: event,
      eventType: "click"
    }, /*#__PURE__*/React.createElement(Button, rest, children));
  };

  return EventButton;
}(React.PureComponent);

export { EventButton as default };
EventButton.defaultProps = {
  children: null
};